// extracted by mini-css-extract-plugin
export var layoutContainer = "_e2-0";
export var layoutContainerNoRounding = "_e2-6";
export var layoutContainerOpen = "_e2-5";
export var layoutContainerResizing = "_e2-1";
export var mainContent = "_e2-2";
export var resizeDivider = "_e2-3";
export var slidePanel = "_e2-4";